import * as React from 'react'
import { ReactElement } from 'react'
import { FieldProps } from '@fluentui/react-field'
import { InsolvencyModuleDto, useFileModule } from '../../../../hooks/module/useFileModule'
import { ModuleType } from '../../../../context/GlobalContext'
import RateFieldsInsolvencyContents from './RateFieldsInsolvencyContents'
import RateFieldsContents from './RateFieldsContents'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../../../config/fileConfig'

export type RateFieldProps = {
    styles: Record<'formRow', string>
    orientation: FieldProps['orientation']
}

export default function RateFields({ styles, orientation }: RateFieldProps): ReactElement {
    const { values } = useFormikContext<FileMutationDto>()
    const { fileModule: insolvencyModule } = useFileModule<InsolvencyModuleDto>(ModuleType.Insolvency, values)

    return (
        <div className={styles.formRow}>
            {insolvencyModule ? (
                <RateFieldsInsolvencyContents styles={styles} orientation={orientation} />
            ) : (
                <RateFieldsContents styles={styles} orientation={orientation} />
            )}
        </div>
    )
}
